import itemId from 'owa-service/lib/factory/itemId';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import markAllItemsAsReadRequest from 'owa-service/lib/factory/markAllItemsAsReadRequest';
import markAllItemsAsReadOperation from 'owa-service/lib/operation/markAllItemsAsReadOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import RequestOptions from 'owa-service/lib/RequestOptions';

export function markAllAsReadService(
    baseFolderId: BaseFolderId,
    markAsRead: boolean,
    itemIdsToExclude: string[],
    suppressReadReceipts: boolean,
    requestOptions: RequestOptions,
    clientLastSyncTime: Date
): Promise<SingleResponseMessage> {
    const baseItemIds =
        itemIdsToExclude != undefined ? itemIdsToExclude.map(id => itemId({ Id: id })) : undefined;

    // VSO 1229 Specify search folder id and focusedViewFilter in case of Focused/Other Inbox views.
    return markAllItemsAsReadOperation(
        {
            Header: getJsonRequestHeader(),
            Body: markAllItemsAsReadRequest({
                ReadFlag: markAsRead,
                SuppressReadReceipts: suppressReadReceipts,
                FromFilter: null,
                FolderIds: [baseFolderId],
                ItemIdsToExclude: baseItemIds,
                ClientLastSyncTime: clientLastSyncTime && clientLastSyncTime.toISOString(),
            }),
        },
        requestOptions
    ).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
